import { useCallback } from "react";
import { getSupabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export function useActivityLog() {
  const { user } = useAuth();
  const supabase = getSupabase();

  const logActivity = useCallback(async (action: string, details: Record<string, unknown> = {}) => {
    if (!user) return;
    try {
      await supabase.from("activity_logs").insert({
        user_id: user.id,
        action,
        details,
      });
    } catch {
      // silently fail - logging shouldn't break the app
    }
  }, [user, supabase]);

  return { logActivity };
}